var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "chart-base",
    {
      ref: "chartbase",
      staticClass: "v-chart-bar",
      attrs: {
        isOffset: true,
        title: _vm.title,
        comment: _vm.comment,
        height: _vm.height,
        width: _vm.width,
        series: _vm.series,
        categories: _vm.categories,
        legend: _vm.legend,
      },
      on: { change: _vm.refresh },
      nativeOn: {
        mousemove: function ($event) {
          return _vm.hover.apply(null, arguments)
        },
        mouseleave: function ($event) {
          return _vm.leave.apply(null, arguments)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "tip",
          fn: function () {
            return [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showTip && _vm.tipIndex > -1
                  ? _c(
                      "div",
                      { staticClass: "v-chart__tip", style: _vm.tipStyle },
                      [
                        _vm.tipText
                          ? _c("div", [_vm._v(_vm._s(_vm.tipText))])
                          : _vm._e(),
                        _c("div", [
                          _vm._v(_vm._s(_vm.barList[_vm.tipIndex].legend)),
                        ]),
                        _c("div", { staticClass: "v-chart__tip__data" }, [
                          _c("i", {
                            staticClass: "v-chart__tip__data__point",
                            style: {
                              background:
                                _vm.legendColor[
                                  _vm.barList[_vm.tipIndex].legend
                                ],
                            },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("format")(
                                  _vm.barList[_vm.tipIndex].value
                                )
                              )
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.tipIndex > -1
          ? _c("rect", {
              attrs: {
                name: "tip-shadow",
                x: _vm.shadowX,
                y: _vm.axis.yStart,
                width: _vm.shadowWidth,
                height: _vm.axis.yHeight,
                fill: "rgba(0,0,0,0.03)",
              },
              on: { click: _vm.click },
            })
          : _vm._e(),
      ]),
      _c(
        "g",
        { attrs: { name: "bar" } },
        _vm._l(_vm.animateBarList, function (t, i) {
          return _c("rect", {
            key: i,
            attrs: {
              x: t.x,
              y: t.y,
              width: t.width,
              height: t.height,
              fill: _vm.legendColor[t.legend],
              stroke: "none",
              "stroke-width": "0",
            },
          })
        }),
        0
      ),
      _vm.showValue && _vm.animatePercent === 1
        ? _c(
            "g",
            { attrs: { name: "value" } },
            _vm._l(_vm.barList, function (t, i) {
              return _c(
                "text",
                {
                  key: i,
                  attrs: {
                    x: t.x + t.width / 2,
                    y: t.y - 3,
                    "font-size": "12",
                    fill: "#565656",
                    "text-anchor": "middle",
                  },
                },
                [_vm._v(_vm._s(_vm._f("format")(t.value)) + " ")]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }